/**
 * @file
 *
 * This file describes the 'Reducer' mapping, is also a good point to define 'Epic' functions.
 * Note that an Action always run first through the reducer before the Epic even receive it.
 * @author JPablo
 */
import { AnyAction } from "redux";
import "rxjs/operators/delay";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import {

    ERROR_OBTENIENDO_XLS_AGRUPADORAS,
    errorConsultandoReporte,
    XLS_OBTENIDO_AGRUPADORAS,
    OBTENER_XLS_PARAMETROS_AGRUPADORAS,
    CONSULTAR_PARAMETROS_AGRUPADORAS,
    parametrosConsultado,
    xlsObtenido,
    errorObteniendoXLS,
    PARAMETROS_CONSULTADO_AGRUPADORAS,
    ERROR_CONSULTANDO_REPORTE_AGRUPADORAS
} from "./parametrosActions";
import * as moment from "moment";
import fileDownload from "js-file-download";


/*
* Epics
* https://redux-observable.js.org/docs/basics/Epics.html
*/

export const consultarParametrosAgrupadorasEpic = action$ =>
    action$.ofType(CONSULTAR_PARAMETROS_AGRUPADORAS)
        .mergeMap((action) => {

            let select = action.filtro.parametro;
            console.log(select);
            let filter = "";
            if (select === 'DNI_EMPRESA') {
                filter = action.filtro.valor ?
                    `dni=${action.filtro.valor}`
                    : "";
            } else if (select === 'TELEFONO') {
                filter = action.filtro.valor ?
                    `telefono=${action.filtro.valor}`
                    : "";
            }
            let ragistroPagina = action.filtro.registrosPorPagina;
            let pagina = action.filtro.pagina;

            filter += ragistroPagina ?
                (filter ? `&registrosPorPagina=${ragistroPagina}` :
                    `registrosPorPagina=${ragistroPagina}`)
                : "";

            filter += pagina ?
                (filter ? `&pagina=${(pagina + 1)}` :
                    `pagina=${(pagina + 1)}`)
                : "";

            const url = `parametros/agrupadoras/obtener-parametros-agrupadoras?${filter}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {

                    const respuesta = JSON.parse(response.response);
                    const dnis = respuesta.datos.dnis;
                    const telefonos = respuesta.datos.telefonos;
                    let final = [];
                    let dniFinal = dnis;
                    let telefonoFinal = telefonos;

                    if (dnis.length > telefonos.length) {
                        telefonoFinal = dnis.map((_, idx) => {
                            return telefonos[idx] || { phone: "" };
                        });
                    } else if (dnis.length < telefonos.length) {
                        dniFinal = telefonos.map((_, idx) => {
                            return dnis[idx] || "";
                        });
                    }
                    final = dniFinal.map((el, idx) => {
                        return { dni: el, phone: telefonoFinal[idx].phone };
                    });


                    return parametrosConsultado(final, respuesta.paginas);
                })
                .catch(response =>
                    [errorConsultandoReporte()]
                );
        });

export const obtenerAgrupadorasXLSEpic = action$ =>
    action$.ofType(OBTENER_XLS_PARAMETROS_AGRUPADORAS)
        .mergeMap((action) => {

            const url = `parametros/reporte/agrupadora`;

            return authenticatedAjax
                .getBlob(
                    url
                )
                .map((response) => {
                    const fileName = `reporte_${moment(moment.now()).format("DDMMYYYY_HH:mm:ss")}.xlsx`;

                    fileDownload(
                        response.response,
                        fileName,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );

                    return xlsObtenido();
                }
                )
                .catch(response =>
                    [errorObteniendoXLS()]
                );
        });



/*
* Reducer
* https://redux.js.org/docs/basics/Reducers.html
 */
export const parametrosAgrupadorasReducer = (state = {
    estado: REQUEST.NONE,
    documentos: [],
    estados: [],
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {
        case CONSULTAR_PARAMETROS_AGRUPADORAS:
            return {
                ...state,
                estado: REQUEST.PENDING,
                documentos: [],
                paginaActual: action.filtro.pagina,
                tamanoPagina: action.filtro.registrosPorPagina
            };
        case PARAMETROS_CONSULTADO_AGRUPADORAS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                documentos: action.documentos,
                paginas: action.paginas
            };
        case ERROR_CONSULTANDO_REPORTE_AGRUPADORAS:
            return { ...state, estado: REQUEST.ERROR, documentos: [] };
        case OBTENER_XLS_PARAMETROS_AGRUPADORAS:
            return { ...state, estadoXLS: REQUEST.PENDING };
        case XLS_OBTENIDO_AGRUPADORAS:
            return { ...state, estadoXLS: REQUEST.SUCCESS };
        case ERROR_OBTENIENDO_XLS_AGRUPADORAS:
            return { ...state, estadoXLS: REQUEST.ERROR };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/co/sura/dominio/parametros/consultar_parametros/modulos/parametrosReducers.ts